export default __webpack_public_path__ + "static/media/image-world-class-talent.406c786c.jpg";